var borders_default = {
  "borderT": "uv-nH",
  "borderB": "_6hKtl",
  "borderL": "e-x-q",
  "borderR": "Wj79N",
  "borderColorOverride": "oRfC2"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
